import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

import { TextField } from '@mui/material';

export default function AdapterField({ name, control, label, customValue, ...rest }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error, invalid } }) => {
        if (customValue) {
          field.value = customValue(field.value);
        }
        return (
          <TextField
            {...field}
            label={label}
            error={invalid}
            helperText={
              error?.message ? (
                <span data-testid="error-message" aria-label="error-message">
                  {error?.message}
                </span>
              ) : (
                ''
              )
            }
            {...rest}
          />
        );
      }}
    />
  );
}

AdapterField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  customValue: PropTypes.func,
};
